appealsQuestions.classy.controller({
    name: 'AppealsQuestionsController',
    inject: ['$scope', '$modal', '$rootScope', '$q', 'authServiceFactory', 'ModelService', 'standardCudArrayFactory', 'AppealsModelService', 'SchoolModelService'],
    init: function()
    {
        this.$.authServiceFactory = this.authServiceFactory;
        this.$.AppealsModelService = this.AppealsModelService;
        this.$rootScope.model = this.AppealsModelService;
        this.$.HelpSystemModelService = this.HelpSystemModelService;

        var self = this;   
        this.$.sortableOptions = {
            stop: function (e, ui) {
                self.$.newOrder = [];
                $(".questionrow").each(function (index) {
                    self.$.newOrder[index] = $(this).attr("id");
                });
                for (let key in self.$.newOrder) {
                    for (let key2 in self.$.AppealsModelService.data) {
                        if (self.$.newOrder[key] == self.$.AppealsModelService.data[key2].recordID) {
                            self.$.AppealsModelService.data[key2].questionOrder = parseInt(key) + 1;
                        }
                    }
                }
                self.$.$apply();
            }
        };

    },
    submit: function(scope, instance, form)
    {
        if (form.$valid)
        {
            instance.options.factor = .3;
            let promiseArray = [];
            for (let i in this.$.AppealsModelService.data) {
                promiseArray.push(this.AppealsModelService.put(this.authServiceFactory.getAuth().schoolID, this.$.AppealsModelService.data[i], instance));
            }
            this.$q.all(promiseArray).then( (response) => {
                this.AppealsModelService.resolveData();
            });
        }
        else
        {
            instance.stop(-1);
        }
    },
    successSave: function(scope, instance, callback) 
    {
        if (typeof callback !== 'undefined')
            callback();  
    },
    AQModal: function(index) 
    {
        return this.$modal.open({
            templateUrl: "fast/submodules/schoolside/settings/parentApp/appealsQuestions/partials/appealsModal.html?v=" + versionNo,
            controller: "AppealsModalController",
            resolve: {
                item: function(authServiceFactory, AppealsModelService) {
                    if (index == undefined)
                      return AppealsModelService.data[AppealsModelService.new()]
                    else
                      return AppealsModelService.data[index]
                },
                index: function() {
                  return index;
                }
            },
            backdrop: 'static',
            keyboard: false
        });
    },
    iframeModal: function()
    {
        return this.$modal.open({
            templateUrl: "fast/submodules/schoolside/settings/parentApp/appealsQuestions/partials/iframe2Modal.html?v=" + versionNo,
            controller: "iframeModalModalController"
        });
    }
});
